import { MultipartAssetUpload } from "./MultipartAssetUpload"

export const customBoundary = "boundary-simpleBoothBoundary"

export async function prepareMultipartAssets(
  files: File[],
  ids?: string[],
): Promise<MultipartAssetUpload[]> {
  const assetUploads: MultipartAssetUpload[] = []
  for (const [index, file] of files.entries()) {
    const buffer = await file.arrayBuffer() // async

    const id = ids !== undefined && ids.length > index ? ids[index] : 0
    assetUploads.push({
      key: file.name,
      mimeType: file.type,
      data: new Uint8Array(buffer),
      id: id,
    })
  }
  return assetUploads
}

export function createCustomMultipartRequestBody(
  jsonData: string,
  assets: MultipartAssetUpload[],
): ArrayBuffer {
  // We'll accumulate parts here (both strings and raw file bytes)
  const chunks: Array<string | Uint8Array> = []

  const appendString = (str: string) => {
    chunks.push(str)
  }

  // 1) The JSON part
  appendString(`--${customBoundary}\r\n`)
  appendString(`Content-Disposition: form-data; name="data"\r\n`)
  appendString(`Content-Type: application/json\r\n\r\n`)
  appendString(jsonData)
  appendString(`\r\n`)

  // 2) Files
  for (const asset of assets) {
    appendString(`\r\n--${customBoundary}\r\n`)
    appendString(`Content-Transfer-Encoding: Binary\r\n`)
    appendString(
      `Content-Disposition: form-data; name="${asset.key}"; filename="${asset.filename ?? "image"}"\r\n`,
    )
    appendString(`Content-Type: ${asset.mimeType}\r\n`)
    if (asset.id !== undefined && asset.id !== null) {
      appendString(`id: ${asset.id}\r\n`)
    }
    if (asset.order !== undefined && asset.order !== null) {
      appendString(`order: ${1}\r\n\r\n`) // TODO: Handle order
    }
    appendString(`\r\n`)

    chunks.push(asset.data)

    appendString(`\r\n`)
  }

  // 3) Closing boundary
  appendString(`--${customBoundary}--\r\n`)

  // Now combine everything into a single ArrayBuffer
  // First, convert all strings to UTF-8 bytes, then flatten everything.
  const encoder = new TextEncoder()

  let totalLength = 0
  for (const chunk of chunks) {
    if (typeof chunk === "string") {
      totalLength += encoder.encode(chunk).byteLength
    } else {
      totalLength += chunk.byteLength
    }
  }

  const combined = new Uint8Array(totalLength)
  let offset = 0
  for (const chunk of chunks) {
    if (typeof chunk === "string") {
      const bytes = encoder.encode(chunk)
      combined.set(bytes, offset)
      offset += bytes.byteLength
    } else {
      combined.set(chunk, offset)
      offset += chunk.byteLength
    }
  }

  return combined.buffer
}
